import { ResidenceTypeOptions } from "@repo/core/constants/proposals";

export const residenceTypeByValue = Object.fromEntries(
  ResidenceTypeOptions.map(({ value, label }) => [value, label])
) as Record<string, string>;

export const getResidenceTypeLabel = (
  residenceType?: string | null
): string | undefined =>
  residenceType ? residenceTypeByValue[residenceType] : undefined;
